module.exports = __webpack_public_path__ + "fca635a9243c513338ef6074f86742a9.svg";